import React from "react";
import ReactDOM from "react-dom";
import { routerMiddleware } from "connected-react-router";
import { createStore, applyMiddleware } from "redux";
import { composeWithDevTools } from "@redux-devtools/extension";
import ReduxThunk from "redux-thunk";
import { Provider } from "react-redux";
import * as serviceWorker from "./serviceWorker";
import axios from "axios";
import { push } from "connected-react-router";

import App from "./App";
import config from "./config";
import createRootReducer from "./reducers";

import { doInit } from "./actions/auth";
import { createHashHistory } from "history";

// ** Fake Database
import "./fakeDB";

const history = createHashHistory();

export function getHistory() {
  return history;
}

axios.defaults.baseURL = config.baseURLApi;
axios.defaults.headers.common["Content-Type"] = "application/json";
const token = localStorage.getItem("token");
if (token) {
  axios.defaults.headers.common["Authorization"] = "Bearer " + token;
}

export const store = createStore(
  createRootReducer(history),
  composeWithDevTools(applyMiddleware(routerMiddleware(history), ReduxThunk))
);

store.dispatch(doInit());

// Response interceptor to handle 401 errors
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      // Remove token from localStorage
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      
      // Remove auth header from axios defaults
      delete axios.defaults.headers.common["Authorization"];

      // Redirect to login page
      store.dispatch(push("/login"));
    }
    return Promise.reject(error);
  }
);

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
